const COMMON_ABBREVIATIONS = [
  "Mr",
  "Mrs",
  "Ms",
  "Dr",
  "Prof",
  "Sr",
  "Jr",
  "vs",
  "etc",
  "i.e",
  "e.g",
  "a.m",
  "p.m",
  "U.S",
  "U.K",
  "St",
  "Ave",
  "Blvd",
  "Rd",
  "Vol",
  "Ph.D"
];
const isAbbreviation = (word) => {
  const cleanWord = word.replace(/\.$/, "");
  return COMMON_ABBREVIATIONS.some((abbr) => cleanWord.toLowerCase() === abbr.toLowerCase() || cleanWord.toLowerCase().replace(/\./g, "") === abbr.toLowerCase());
};
const countWords = (text) => text.trim().split(/\s+/).length;
const findCueForWordPosition = (cues, wordPositions) => {
  let wordCount = 0;
  for (const cue of cues) {
    const cueWords = countWords(cue.text);
    if (wordCount + cueWords > wordPositions.start) {
      return {
        cue,
        wordOffset: wordPositions.start - wordCount
      };
    }
    wordCount += cueWords;
  }
  return {
    cue: cues[cues.length - 1],
    wordOffset: 0
  };
};
const needsCleanup = (transcriptLines) => {
  const linesToCheck = Math.min(5, transcriptLines.length);
  let periodsFound = 0;
  let longLinesWithoutPeriod = 0;
  for (let i = 0; i < linesToCheck; i++) {
    const line = transcriptLines[i];
    if (line.text.includes(".")) {
      periodsFound++;
    } else if (line.text.length > 50) {
      longLinesWithoutPeriod++;
    }
  }
  return !(periodsFound <= 1 && longLinesWithoutPeriod >= 2) && periodsFound !== 0;
};
const calculateTiming = (startCueInfo, endCueInfo) => {
  const startCueWordRatio = startCueInfo.wordOffset / countWords(startCueInfo.cue.text);
  const startTime = startCueInfo.cue.startTime + (startCueInfo.cue.endTime - startCueInfo.cue.startTime) * startCueWordRatio;
  const endCueWordRatio = (endCueInfo.wordOffset + 1) / countWords(endCueInfo.cue.text);
  const endTime = endCueInfo.cue.startTime + (endCueInfo.cue.endTime - endCueInfo.cue.startTime) * endCueWordRatio;
  return {
    startTime,
    endTime
  };
};
const splitSentences = (text) => {
  return (text + " ").split(/(?<=[.!?])\s+/).reduce((acc, part) => {
    if (acc.length > 0) {
      const lastSentence = acc[acc.length - 1];
      const lastWord = lastSentence.trim().split(/\s+/).pop() || "";
      if (isAbbreviation(lastWord)) {
        acc[acc.length - 1] = `${lastSentence} ${part}`;
        return acc;
      }
    }
    acc.push(part);
    return acc;
  }, []).filter((s) => s.trim().length > 0);
};
const heuristicTranscriptLines = (transcriptLines) => {
  if (!needsCleanup(transcriptLines)) {
    return transcriptLines;
  }
  const cleanedLines = [];
  let currentSentence = "";
  let currentStartTime = 0;
  let lastEndTime = 0;
  let originalLines = [];
  for (let i = 0; i < transcriptLines.length; i++) {
    const line = transcriptLines[i];
    const nextLine = i < transcriptLines.length - 1 ? transcriptLines[i + 1] : null;
    const startTime = currentSentence ? currentStartTime : line.startTime;
    const fullText = currentSentence + (currentSentence && line.text ? " " : "") + line.text;
    const shouldLookAhead = nextLine && (/[a-z]/.test(nextLine.text[0]) || !/[.!?]$/.test(fullText));
    if (shouldLookAhead) {
      currentSentence = fullText;
      currentStartTime = startTime;
      lastEndTime = line.endTime;
      if (!originalLines.includes(line)) {
        originalLines.push(line);
      }
      continue;
    }
    if (!originalLines.includes(line)) {
      originalLines.push(line);
    }
    const sentences = splitSentences(fullText);
    currentSentence = "";
    if (sentences.length === 0) {
      cleanedLines.push({
        startTime,
        endTime: line.endTime,
        text: fullText.trim(),
        hash: `${startTime}-${line.endTime}-${fullText.trim()}`
      });
      originalLines = [];
      continue;
    }
    let wordPosition = 0;
    sentences.forEach((sentence) => {
      const sentenceWords = countWords(sentence);
      const sentenceStart = wordPosition;
      const sentenceEnd = wordPosition + sentenceWords;
      const startCueInfo = findCueForWordPosition(originalLines, {
        start: sentenceStart});
      const endCueInfo = findCueForWordPosition(originalLines, {
        start: sentenceEnd - 1});
      const { startTime: startTime2, endTime } = calculateTiming(startCueInfo, endCueInfo);
      cleanedLines.push({
        startTime: startTime2,
        endTime,
        text: sentence.trim(),
        hash: `${startTime2}-${endTime}-${sentence.trim()}`
      });
      wordPosition += sentenceWords;
    });
    originalLines = [];
  }
  if (currentSentence) {
    cleanedLines.push({
      startTime: currentStartTime,
      endTime: lastEndTime,
      text: currentSentence.trim(),
      hash: `${currentStartTime}-${lastEndTime}-${currentSentence.trim()}`
    });
  }
  return cleanedLines;
};

export { heuristicTranscriptLines };
//# sourceMappingURL=heuristicTranscriptLines.js.map
